<template>
  <div id="save_userInfo">
    <el-header>
      <top-Nav></top-Nav>
    </el-header>
    <div class="monitor_wrap el-main" :style="{height:basicHeight+'px'}">
      <div class="mainHead">
        <div class="route">
          <span class="crumbs"></span><span class="router_link" @click="linkIndex">用户管理</span><span class="arrow">></span><span class="router_link" @click="linkDetail">{{msg}}</span><span class="arrow">></span><span>保存成功</span>
        </div>
        <div>
          <el-button type="primary" @click="returnBtn">返回</el-button>
        </div>
      </div>
      <div class="main clearfix">
        <div>
          <p class="tip_size"><img src="../../../src/assets/img/save_success.png" alt="">保存成功</p>
        </div>
        <div class="result_btn">
          <el-button type="primary" @click="addUserInfo" v-if="isAuth('users:addUser')">新增用户</el-button>
          <el-button type="primary" @click="lookUserInfo">查看用户信息</el-button>
          <el-button type="primary" @click="givePerssion" v-if="isAuth('userMonitoring:binUserMonitor')">给当前用户授权</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import "@/assets/css/mixin.scss";
  .el-main{
    width: 98%;
  }
  .main{
      padding-top: 145px;
      background: #fff;
      /*height: 100%;*/
      text-align: center;
  }
  .monitor_wrap{
    height: 100%;
    background: #fff;
  }
  .router_link:hover{
    cursor: pointer;
    color: #198cff;
  }
  .result_btn{
    padding-top: 60px;
  }
  .result_btn button{
    width: 200px;
    height: 40px;
    font-size: 16px;
  }
  .tip_time{
    color: #282828;
    padding: 20px 0 30px;
  }
  .tip_size{
    font-size: 28px;
    color: #45B351;
    font-weight: bold;
  }
  .tip_size img{
    width: 36px;
    height: 36px;
    vertical-align: middle;
    margin-right: 10px;
  }
</style>

<script>
  import topNav from '../../components/TopNav.vue';
  export default {
    name:'saveUserInfoSuccess',
    components:{
      topNav
    },
    data(){
      return{
        widthNum: '',   //中间区域自适应宽度
        widthCard: '', //计算卡片宽度
        widthText: '', //计算卡片文本宽度
        total:0,
        monitorList:[],
        basicHeight:'',
        id:'',
        msg:'编辑用户',
      }
    },
    created() {
      this.id=this.$route.query.id;
      if(this.$route.query.type==='edit'){
        this.msg='编辑用户';
      }else {
        this.msg='新增用户';
      }
    },
    computed:{

    },
    methods:{
      linkIndex(){
        this.$router.push({path:'/userManger'});
      },
      //新增用户
      addUserInfo(){
        this.$router.push({path:'/editUser',query:{type:'add'}})
      },
      //查看用户信息
      lookUserInfo(){
        this.$router.push({path:'/searchUserInfo',query:{id:this.id}});
      },
      //授权
      givePerssion(){
        this.$router.push({path:'/permissions',query:{id:this.id}});
      },
      linkDetail(){
        if(this.$route.query.type==='edit'){
          if(this.$route.query.runStatus==='0'){
            this.$router.push({path:'/editUser',query:{id:this.id,type:'edit',runStatus:'0'}});
          }else {
            this.$router.push({path:'/editUser',query:{id:this.id,type:'edit'}});
          }
        }else {
          this.$router.push({path:'/editUser',query:{type:'add'}});
        }
      },
      returnBtn(){ //返回按钮;
        this.$router.push({path:'/userManger'});
      },
    },
    mounted(){
        this.basicHeight=$(document).height()-81;
    },
    destroyed(){

    },
  }
</script>



// WEBPACK FOOTER //
// src/page/systemManger/saveSuccess.vue